<a id="{{Id}}-Hyperlink" *ngIf="!dataItem.Inactive && columnInfoDto.IsClickable(dataItem); else notClickable" (click)="columnInfoDto.HyperlinkCallback(dataItem)">
  <ap-hyperlink-column-selector [baseId]="baseId"
                                [columnName]="columnName"
                                [columnInfoDto]="columnInfoDto"
                                [dataItem]="dataItem">
  </ap-hyperlink-column-selector>
</a>
<ng-template #notClickable>
    <ap-hyperlink-column-selector [baseId]="baseId"
      [columnName]="columnName"
      [columnInfoDto]="columnInfoDto"
      [dataItem]="dataItem">
  </ap-hyperlink-column-selector>
</ng-template>

